import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import Datum from '../Datum/Tree';
import { curry } from '../utils/func';
import { mergeFilteredTree } from '../utils/tree';
import { treeClass } from '../Tree/styles';
import { treeSelectClass } from './styles';
import { Component } from '../component';
var DefaultProps = {
  childrenKey: 'children'
};
export default curry(function (options, Origin) {
  var _options$dataKey = options.dataKey,
      dataKey = _options$dataKey === void 0 ? 'data' : _options$dataKey;

  var Tiled =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Tiled, _Component);

    var _super = _createSuper2(Tiled);

    function Tiled(props) {
      var _this;

      _classCallCheck(this, Tiled);

      _this = _super.call(this, props);
      _this.rawDatum = void 0;
      _this.filteredDatum = void 0;
      _this.state = {
        tileds: []
      };
      _this.getIcon = _this.getIcon.bind(_assertThisInitialized(_this));
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
      if (props.onAdvancedFilter) _this.genRawDatum();
      return _this;
    }

    _createClass(Tiled, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.rawData !== this.props.rawData && this.props.onAdvancedFilter) {
          if (this.rawDatum) this.rawDatum.setData(this.props.rawData);else this.genRawDatum();
          this.forceUpdate();
        }
      }
    }, {
      key: "getFilteredDatum",
      value: function getFilteredDatum() {
        var _this$props = this.props,
            keygen = _this$props.keygen,
            childrenKey = _this$props.childrenKey;
        var data = this.props[dataKey];
        if (this.filteredDatum && this.filteredDatum.data === data) return this.filteredDatum;
        this.filteredDatum = new Datum({
          data: data,
          keygen: keygen,
          childrenKey: childrenKey || DefaultProps.childrenKey
        });
        return this.filteredDatum;
      }
    }, {
      key: "getIcon",
      value: function getIcon(data) {
        var _this$props2 = this.props,
            childrenKey = _this$props2.childrenKey,
            _this$props2$expanded = _this$props2.expanded,
            expanded = _this$props2$expanded === void 0 ? [] : _this$props2$expanded;
        var originIcon =
        /*#__PURE__*/
        React.createElement("span", {
          className: treeClass('default-icon')
        });
        var key = this.rawDatum.getKey(data);
        var rawData = this.rawDatum.getDataById(key);
        if (!data || !rawData) return originIcon;
        var sameCount = data[childrenKey] && rawData[childrenKey] && data[childrenKey].length === rawData[childrenKey].length;
        if (expanded.indexOf(key) === -1) return originIcon;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: treeSelectClass('match', sameCount && 'full'),
            onClick: this.handleToggle.bind(this, key)
          },
          /*#__PURE__*/
          React.createElement("span", null))
        );
      }
    }, {
      key: "handleFilter",
      value: function handleFilter(text, from) {
        var onFilter = this.props.onFilter;
        if (!text) this.setState({
          tileds: []
        });
        if (onFilter) onFilter(text, from);
      }
    }, {
      key: "handleToggle",
      value: function handleToggle(key, e) {
        e.stopPropagation();
        this.setState(immer(function (draft) {
          var index = draft.tileds.indexOf(key);
          if (index >= 0) draft.tileds.splice(index, 1);else draft.tileds.push(key);
        }));
      }
    }, {
      key: "genRawDatum",
      value: function genRawDatum() {
        var _this$props3 = this.props,
            rawData = _this$props3.rawData,
            _this$props3$children = _this$props3.childrenKey,
            childrenKey = _this$props3$children === void 0 ? DefaultProps.childrenKey : _this$props3$children,
            keygen = _this$props3.keygen;
        this.rawDatum = new Datum({
          data: rawData,
          childrenKey: childrenKey,
          keygen: keygen
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
            filterText = _this$props4.filterText,
            onAdvancedFilter = _this$props4.onAdvancedFilter;
        var tileds = this.state.tileds;
        if (!filterText || !onAdvancedFilter) return (
          /*#__PURE__*/
          React.createElement(Origin, this.props)
        );
        var expandIcons = [this.getIcon, this.getIcon];
        var filterDatum = this.getFilteredDatum();
        var data = mergeFilteredTree(filterDatum, this.rawDatum, tileds);

        var props = _objectSpread2(_objectSpread2({}, this.props), {}, _defineProperty({
          onFilter: this.handleFilter,
          expandIcons: expandIcons
        }, dataKey, data));

        return (
          /*#__PURE__*/
          React.createElement(Origin, props)
        );
      }
    }]);

    return Tiled;
  }(Component);

  Tiled.defaultProps = DefaultProps;
  return Tiled;
});
export var advancedFilterHOC = function advancedFilterHOC(Origin) {
  return function (props) {
    var onAdvancedFilter = props.onAdvancedFilter,
        onFilter = props.onFilter;
    return (
      /*#__PURE__*/
      React.createElement(Origin, Object.assign({}, props, {
        onFilter: onAdvancedFilter || onFilter,
        onAdvancedFilter: !!onAdvancedFilter
      }))
    );
  };
};